import { TransactionType } from '@repo/database/src/types';

export interface AdminBulkTransferUser {
  error: string | null;
  userId: string | null;
  amount: number;
  alias: string;
  transactionId: string | null;
}

export interface AdminBulkTransferRequest {
  users: AdminBulkTransferUser[];
  transactionType?: TransactionType;
}

export interface AdminBulkTransferDto {
  error: boolean;
  users: AdminBulkTransferUser[];
}
